type Style = string | undefined;

/**
 * convert an array of styles into a string to pass to `className`
 * @param styles
 */
export default function concatStyles(styles: Style[]) {
  return styles.filter((item) => item !== undefined).join(' ');
}
